import { RoutePathProps } from "../../../../AppRoutes/types"

import SellIcon from '@mui/icons-material/Sell';


const salesInvoice: RoutePathProps = {
    name: 'salesInvoice',
    path: 'salesInvoice',
    label: "Sales Invoices",
    visibleInNav: true,
    requiredPermission: 'sales-invoice:list',
    children: [{
        name: 'createSalesInvoice',
        path: 'createSalesInvoice',
        label: 'Create Sales Invoice',
        requiredPermission: 'sales-invoice:create'
    },
    {
        name: 'showSalesInvoice',
        path: ':invoiceId',
        label: 'Show Sales Invoice',
        requiredPermission: 'sales-invoice:read'
    },
    {
        name: 'updateSalesInvoice',
        path: 'updateSalesInvoice/:id',
        label: 'Update Sales Invoice',
        requiredPermission: 'sales-invoice:update'
    }
    ]
}

const quotation: RoutePathProps = {
    name: 'quotation',
    path: 'quotation',
    label: "Quotation",
    visibleInNav: true,
    requiredPermission: 'quotation:list',
    children: [{
        name: 'createQuotation',
        path: 'createQuotation',
        label: 'Create Quotation',
        requiredPermission: 'quotation:create'
    },
    {
        name: 'showQuotation',
        path: ':quotationId',
        label: 'Show Quotation',
        requiredPermission: 'quotation:read'
    },
    {
        name: 'updateQuotation',
        path: 'updateQuotation/:id',
        label: 'Update Quotation',
        requiredPermission: 'quotation:update'
    }]
}

const paymentIn: RoutePathProps = {
    name: 'paymentIn',
    path: 'paymentIn',
    label: "Payment In",
    visibleInNav: true,
    requiredPermission:'payment-in:list',
    children: [{
        name: 'createPaymentIn',
        path: 'createPaymentIn',
        label: 'Create Payment In',
        requiredPermission:'payment-in:create'
    },
    {
        name: 'showPaymentIn',
        path: ':paymentInId',
        label: 'Show Payment In',
        requiredPermission:'payment-in:read'
    },
    {
        name: 'updatePaymentIn',
        path: 'updatePaymentIn/:id',
        label: 'Update Payment In',
        requiredPermission:'payment-in:update'
    }]
}

const salesReturn: RoutePathProps = {
    name: 'salesReturn',
    path: 'salesReturn',
    label: "Sales Return",
    visibleInNav: true,
    requiredPermission:'sales-return:list',
    children: [{
        name: 'createSalesReturn',
        path: 'createSalesReturn',
        label: 'Create Sales Return',
        requiredPermission:'sales-return:create'
    },
    {
        name: 'showSalesReturn',
        path: ':salesReturnId',
        label: 'Show Sales Return',
        requiredPermission:'sales-return:read'
    },
    {
        name: 'updateSalesReturn',
        path: 'updateSalesReturn/:id',
        label: 'Update Sales Return',
        requiredPermission:'sales-return:update'
    }]
}

const creditNote: RoutePathProps = {
    name: 'creditNote',
    path: 'creditNote',
    label: "Credit Note",
    visibleInNav: true,
    requiredPermission:'credit-note:list',
    children: [{
        name: 'createCreditNote',
        path: 'createCreditNote',
        label: 'Create Credit Note',
        requiredPermission:'credit-note:create'
    },
    {
        name: 'showCreditNote',
        path: ':creditNoteId',
        label: 'Show Credit Note',
        requiredPermission:'credit-note:read'
    },
    {
        name: 'updateCreditNote',
        path: 'updateCreditNote/:id',
        label: 'Update Credit Note',
        requiredPermission:'credit-note:update'
    }]
}

export const sales: RoutePathProps = ({
    name: 'sales',
    path: 'sales',
    label: 'Sales',
    visibleInNav: true,
    icon: SellIcon,
    dummy: true,
    children: [salesInvoice, quotation, paymentIn, salesReturn, creditNote],
    requiredPermission:'sales:list'
})

